module.exports = __webpack_public_path__ + "static/img07-9558b743dca3b481da2a8fb4006fda8b.jpg";